export const USER="User";
export const SUPER_ADMIN="Super Admin";
export const ADMIN="Admin";